export const SAPI_ERROR_MESSAGE_ID = 'sapi_error_message';
export const DEFAULT_TIMEOUT_SUCCESS = 6000;

export const CUSTOM_MESSAGE_COMPONENTS = {
	PURCHASE_ORDER_STATUS_MESSAGE: 'PurchaseOrderStatusMessage',
} as const;
